import React from 'react';

const Footer = () => {
  return (
    <footer className="mt-5">
      <p>
        Made with{' '}
        <span role="img" aria-label="">
          💕
        </span>{' '}
        |{' '}
        <a href="https://dickymr.com/" target="_blank" rel="noreferrer noopener">
          Dicky Muhamad R
        </a>
        .
      </p>
    </footer>
  );
};

export default Footer;
